module.exports = __webpack_public_path__ + "img/introduction_bg.610a9c06.png";